module.exports = __webpack_public_path__ + "img/ตะวันออก.67a3b67f.jpg";